<template>
  <div>
    <div
      class="container-fluid pt-4"
    >
      <div class="section-title">
        Xml Import Report
      </div>
      <div
        class="row"
      >
        <div class="col-lg-12">
          <Report
            :report-entry="reportEntry"
            :show-close-button="false"
            :show-reprocess-action="true"
            :recalculate-with-image-report="true"
          />
        </div>
      </div>
      <div
        v-if="login && loaded && !reportEntry"
      >
        No import report present for <strong>{{ login }}</strong> yet
      </div>
      <div v-if="!login">
        No login parameter specified
      </div>
    </div>
  </div>
</template>

<script>
import Report from './report.vue';
import xmlimportsapi from '../../../xmlimportapi';
import notify from '../../../notifications';

export default {
    components: {
        Report
    },
    data() {
        return {
            reportEntry: null,
            loaded: false,
            login: null
        };
    },
    methods: {
        async search() {
            if ( !this.login ) {
                return;
            }

            const url = `/history/${ this.login }?take=1`;

            this.$store.dispatch( 'appLoading', true );

            const response = await xmlimportsapi.get( url );

            this.$store.dispatch( 'appLoading', false );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load import history'
                } );
                this.disabled = false;

                return;
            }

            let entries = await response.json();

            this.loaded = true;

            if ( entries.length == 0 ) {
                return;
            }

            this.reportEntry = entries[ 0 ];
        }
    },
    async mounted() {
        this.login = this.$route.query.login;
        await this.search();
    }
};
</script>




// WEBPACK FOOTER //
// src/components/dashboard/xmlimport/ImportReport.vue